var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileIconPptx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "111px",
    height: "108px",
    viewBox: "0 0 111 108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Microsoft Powerpoint 2013 Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Microsoft-Powerpoint-2013-Logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "microsoft-powerpoint-2013",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.893,0 L64.98,0 L64.98,11.25 C78.343,11.325 91.718,11.112 105.068,11.312 C107.943,11.037 110.193,13.274 109.906,16.149 C110.118,39.499 109.856,62.861 110.031,86.224 C109.906,88.749 110.281,91.549 108.831,93.786 C107.006,95.111 104.631,94.936 102.493,95.036 C89.993,94.974 77.493,94.999 64.98,94.999 L64.98,107.499 L57.206,107.499 C38.156,104.024 19.068,100.849 0.006,97.499 C-0.007,68.337 0.006,39.174 0.006,10.024 C19.292,6.688 38.58,3.288 57.893,0 Z",
    id: "Shape",
    fill: "#D24625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.98,15 L106.23,15 L106.23,91.25 L64.98,91.25 L64.98,81.25 L94.98,81.25 L94.98,76.25 L64.98,76.25 L64.98,70 L94.98,70 L94.98,65 L64.993,65 C64.98,62.55 64.98,60.1 64.969,57.65 C69.919,59.187 75.556,59.15 79.981,56.174 C84.769,53.337 87.269,47.924 87.681,42.524 C82.194,42.486 76.706,42.499 71.231,42.499 C71.219,37.061 71.293,31.624 71.119,26.199 C69.069,26.599 67.019,27.024 64.981,27.461 L64.981,15 L64.98,15 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.743,23.587 C82.431,23.987 89.73,31.299 90.193,39.962 C84.705,40.025 79.218,40 73.73,40 C73.73,34.525 73.718,29.05 73.743,23.587 Z",
    id: "Shape",
    fill: "#D24625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.055,33.025 C26.843,33.35 35.068,30.337 40.693,35.425 C46.081,41.963 44.656,53.987 36.668,57.901 C33.831,59.35 30.581,59.151 27.493,59.05 C27.48,63.938 27.469,68.825 27.48,73.713 C25.0012592,73.4976744 22.521916,73.2893403 20.042,73.088 C19.93,59.737 19.906,46.375 20.055,33.025 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.48,39.788 C29.943,39.675 32.993,39.226 34.656,41.538 C36.081,43.988 36.006,47.213 34.818,49.738 C33.393,52.313 30.168,52.063 27.68,52.363 C27.417,48.175 27.443,43.987 27.48,39.788 Z",
    id: "Shape",
    fill: "#D24625"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIconPptx);
export default __webpack_public_path__ + "static/media/fileIcon-pptx.1b5146a1d5a11eae1edf8f7a18205cfd.svg";
export { ForwardRef as ReactComponent };